(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-share"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.article-share__copy').forEach((btn) => {
    btn.addEventListener('click', async (event) => {
      const url = event.currentTarget.dataset.shareUrl;
      if (!url) return;
      try {
        await navigator.clipboard.writeText(url);
        event.currentTarget.setAttribute('data-copied', 'true');
        setTimeout(() => event.currentTarget.removeAttribute('data-copied'), 1500);
      } catch (e) {
        window.prompt('Copy this link to share:', url);
      }
    });
  });

  document.querySelectorAll('.article-share--rail').forEach((rail) => {
    const startSelector = rail.dataset.railAnchorStart;
    const endSelector = rail.dataset.railAnchorEnd;
    const stickyTop = parseInt(rail.dataset.railStickyTop, 10) || 100;
    const initialTopDoc = parseInt(rail.dataset.railInitialTop, 10) || 0;
    const useFixedInitial = initialTopDoc > 0;
    if (!startSelector || !endSelector) return;

    const startMatches = document.querySelectorAll(startSelector);
    const endMatches = document.querySelectorAll(endSelector);
    const startEl = startMatches[0];
    const endEl = endMatches[endMatches.length - 1];
    if (!endEl || (!useFixedInitial && !startEl)) return;

    const desktopMQ = window.matchMedia('(min-width: 1139px)');
    let rafId = null;

    const apply = () => {
      rafId = null;
      if (!desktopMQ.matches) {
        rail.classList.remove('is-positioned');
        rail.style.top = '';
        return;
      }
      const initialViewportTop = useFixedInitial
        ? initialTopDoc - window.scrollY
        : startEl.getBoundingClientRect().top;
      const endBottom = endEl.getBoundingClientRect().bottom;
      const railHeight = rail.offsetHeight;
      let top;
      if (initialViewportTop > stickyTop) {
        top = initialViewportTop;
      } else if (endBottom - railHeight > stickyTop) {
        top = stickyTop;
      } else {
        top = endBottom - railHeight;
      }
      rail.style.top = top + 'px';
      rail.classList.add('is-positioned');
    };

    const schedule = () => {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(apply);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    desktopMQ.addEventListener('change', schedule);
    apply();
  });

  } catch(e) { console.error(e); }
})();
})();
